export interface IDealSheet {
  id: string;
  dealId: string;
  isPurchase: boolean;
  fundedDate: string;
  flStampFee: number;
  vsiFee: number;
  amount: number;
  dealNumericId: number | null;
  appearanceProtCost: number;
  appearanceProtRetail: number;
  acceleratedTitleTransactionCharges: number | null;
  acceleratedTitleTaxes: number | null;
  dealerTrackPayoffAmount: number | null;
  customerRefundAmount: number | null;
  totalPackTitleFee: number | null;
  cashOut: number;
  cashReceived: number;
  cityTaxRate: number;
  countyTaxRate: number;
  downPayment: number;
  gapCost: number;
  gapRetail: number;
  comCost: number;
  comRetail: number;
  maintenanceCost: number;
  maintenanceRetail: number;
  otherFees: number;
  otherTaxRate: number;
  pack: number;
  payoff: number;
  perDiem: number;
  purchaseDownPayment: number;
  rtdTaxRate: number;
  totalPayoff: number;
  costOfProducts: number;
  gapPack: number;
  warrantyPack: number;
  appearanceProtPack: number;
  comCommissionable: number;
  comPack: number;
  totalCom: number;
  vrpPack: number;
  gapCommissionable: number;
  totalGap: number;
  warrantyCommissionable: number;
  totalWarranty: number;
  appearanceProtCommissionable: number;
  totalAppearanceProt: number;
  vrpCommissionable: number;
  totalVrp: number;
  totalPackDocFee: number;
  otherPayable: number;
  existingAdjustments: [{ adjustmentPayOff: number; totalAdjustment: number; amountFinanced: number; id?: number }];
  stateTaxRate: number;
  tireWheelCost: number;
  tireWheelRetail: number;
  titleSOR: number;
  tradeAllowanceDeal: number;
  tradeInActCashValue: number;
  tradeInValue: number;
  tradePayoff: number;
  warrantyCost: number;
  warrantyRetail: number;
  windowEtchingCost: number;
  windowEtchingRetail: number;
  windshieldProtCost: number;
  windshieldProtRetail: number;
  warrantyType: string;
  agentUserId: string;
  address1: string;
  address2: string;
  contactStatus: string;
  customerName: string;
  last6OfVINNumber: string;
  lcName: string;
  lenderId: string;
  lenderName: string;
  licenseSor: number;
  lienAccountNumber: string;
  lienHolder: string;
  vin: string;
  dealTradeIns: string;
  netTrade: string;
  payoffSource: string;
  payOffDate: string;
  payoffDateOnAuth: string;
  commissionPercent: number;
  cudlAmountFinanced: number;
  d_H: number;
  flatParticipation: number;
  transportation: number;
  coTempTag: number;
  downPaymentTo: string;
  paidOutDescription: string;
  purchasePayOff: number;
  taxesFeesPaidToOthers: number;
  tradePerDiem: number;
  tradePayOffDate: string;
  tradePayoffDateOnAuth: string;
  lenderFee: number;
  paidOutOfGross: number;
  vehicleCost: number;
  vehicleSellingPrice: number;
  appraiser: string;
  stockNumber: string;
  taxesTo: string;
  trade1StockNum: string;
  trade1Vin: string;
  trade2StockNum: string;
  trade2Vin: string;
  tradeInTo: string;
  tradePayoffSource: string;
  vehicleBoughtFrom: string;
  adjustedPayoff: number;
  cityTax: number;
  commission: number;
  countyTax: number;
  dealTotal: number;
  gpAppearProt: number;
  gpBackEnd: number;
  gpDeal: number;
  gpFlatParticipation: number;
  gpFrontEnd: number;
  gpGap: number;
  gpCom: number;
  gpMaintenance: number;
  gpTireWheel: number;
  gpWarranty: number;
  gpWindowEtch: number;
  gpWindshieldProt: number;
  otherTax: number;
  rtdTax: number;
  stateTax: number;
  taxableAmount: number;
  totalGrossProfit: number;
  vehiclePayout: number;
  chartWayDonations: number;
  dealSheetStatusCD: string;
  isCurrent: boolean;
  isNegative: boolean;
  appearanceProtTax: number;
  gapTax: number;
  comTax: number;
  warrantyTax: number;
  vrpRetail: number;
  vrpCost: number;
  vrpTax: number;
  mbaRetail: number;
  mbaCost: number;
  mbaTax: number;
  mbaPack: number;
  gpVrp: number;
  syncToAcumaticaStatus: number;
  registrationFee: number;
  payoffAmountActual: number;
  payoffGoodDateActual: string;
  payoffPerDiemActual: number;
  contactId: string;
  lienHolderId: string;
  createdDate: string;
  updatedDate: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lender?: any;
  reserveNonCommissionable: number;
  reserveCommissionable: number;
  totalReserve: number;
  adjustedPayoffCommissionable: number;
  adjustedPayoffNonCommissionable: number;
  totalAdjustedPayoff: number;
  otherAdjustmentsCommissionable: number;
  otherAdjustmentsNonCommissionable: number;
  totalOtherAdjustments: number;
  otherFeesCommissionable: number;
  otherFeesNonCommissionable: number;
  totalOtherFees: number;
  packDocFeeCommissionable: number;
  packDocFeeNonCommissionable: number;
  mbaCommissionable: number;
  mbaNonCommissionable: number;
  totalMba: number;
  totalCommissionable: number;
  totalNonCommissionable: number;
  total: number;
}

export interface IDealSheetPanelProps {
  customerName: string;
  dealSheets?: IDealSheet[];
  refresh: () => void;
  dealId: string;
}

export interface IDSHistoryProps {
  data: IDealSheet[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: (rowId: unknown) => Promise<void>;
  historyIndex: number;
  handleCreateNew: () => void;
  requestNavigateBtn: () => void;
}

export interface IDSProps {
  data?: IDealSheet;
  refresh?: () => void;
}

export enum RevenueType {
  GAP = 'GAP',
  VSC = 'VSC',
  MBI = 'MBI',
  MBA = 'MBA',
  PAF = 'PAF',
  VRP = 'VRP',
  COM = 'COM',
  RESERVE = 'Reserve',
  ADJPAYOFF = 'Adjusted PayOff',
  OTHERADJUST = 'Other Adjustments',
  OTHERFEES = 'Other Fees',
  PACKDOC = 'Pack/Doc Fee',
  TOTAL = 'Total',
}

export enum DSColumn {
  cashReceived = 'Cash Received',
  // eslint-disable-next-line quotes
  downPayment = "Dowm Pmnt Rec'd",
  totalPayoff = 'Total Payoff',
  flStampFee = 'FL Stamp Fee',
  vsiFee = 'VSI Fee',
  costOfProduction = 'Cost Of Product(s)',
  otherPayable = 'Other Payable/Fees',
  totalRevenue = 'Total Revenue',
  fundedDate = 'Funded Date',
  amountFinanced = 'Amount Financed',
  flatReserv = 'Flat/ Reserve',
  contractedPayoff = 'Contracted Payoff',
  lenderFee = 'Lender Fee',
  dealerTrackPayoff = 'Dealertrack Payoff',
  customerRefund = 'Customer Refund',
  packDocFee = 'Pack/ Doc Fee',
  packTitleFee = 'Pack/ Title Fee',
  downPaymentSec = 'Down Payment',
  salesTax = 'Sales Tax',
  registrationFee = 'Registration Fess',
  cashOut = 'Cash Out',
  dealerTrackFees = 'Dealer Track Fees',
  dealerTrackTaxes = 'Dealer Track Taxes',
  amount = 'Amount',
  goodThrough = 'Good Through',
  perDiem = 'Per Diem',
}

type tableValues = number | string | undefined | null;

export interface IDealSheetTableData {
  id: number;
  title: DSColumn;
  title2?: DSColumn;
  value2?: tableValues;
  value?: tableValues;
  editable?: boolean;
  type?: string;
}

export interface IDealSheetData {
  data: IDealSheetTableData[];
  title: string;
  setFundedDate?: React.Dispatch<React.SetStateAction<string | null>>;
}

export interface IAdjustmentModalProps {
  dealId?: string;
  contactId?: string;
  setOpenAdjustmentModal: React.Dispatch<React.SetStateAction<boolean>>;
  refresh?: () => void;
}
